import { connect } from "react-redux";
import { history } from "../store";
import { isDistrictAdmin } from "../utils/objects";

import ViewInstitution from "../components/ViewInstitution";
import * as selectors from "../selectors";
import * as actions from "../actions";

const mapStateToProps = (state, ownProps) => {
  const user = selectors.getUser(state) || {};
  const institution = selectors.getInstitutionDetail(state) || {};

  return {
    institution,
    user,
    institution_key: ownProps.routeParams.key,
    isFetchingInstitution: selectors.isFetchingInstitution(state),
    mayEdit:
      user.is_admin ||
      isDistrictAdmin(user, institution.area) ||
      (institution.owner && user._key === institution.owner)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadEntry: key => dispatch(actions.fetchInstitution(key)),
    onEditInstitution: key => dispatch(actions.editInstitution(key)),
    onClose: () => history.goBack()
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewInstitution);



/** WEBPACK FOOTER **
 ** ./src/containers/ViewInstitutionContainer.js
 **/